<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اسم المدينة</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "cityForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <!-- appDisableWeritingArabic -->

                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم المدينة</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>

                             <div class="col-6 mb-3">
                                <label for="validationCustom02"><span class="validation-required">*</span> المحافظة</label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="governorateId"
                                    class="form-control p-0" placeholder="اختر المحافظة"
                                    containerClass="" 
                                    id="validationCustom02">
                                    <ng-option *ngFor="let item of governrate" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                       </div>
                            
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

